export default {
	Auth: {
		region: 'eu-west-1',
		userPoolId: 'eu-west-1_3hjmkZeAN',
		userPoolWebClientId: '6nc3cibr4kfe2qoiftg8trljjc',
		identityPoolId: 'eu-west-1:7d1cf66b-908a-4351-9847-c436f8edab9f'
	},
	Storage: {
		AWSS3: {
			bucket: 'primarweb-uploads', //REQUIRED -  Amazon S3 bucket
			region: 'eu-west-1' //OPTIONAL -  Amazon service region
		}
	},

	API_PATH: 'https://a2hm01slx3.execute-api.eu-west-1.amazonaws.com/latest',

	DistributorsMapUrl: 'https://primar.ecc.no/primar/report/json?r=distributorsByCountry',
	DistributorsUrl: 'https://primar.ecc.no/primar/api/rest/distributorService/distributors/commersial',
	S100CoverageUrl: 'https://primar.ecc.no/primar/api/rest/product-types/available'
}
